module.exports = __webpack_public_path__ + "static/media/tubz_tower.e4fbce13.jpeg";